import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Box, Chip, TableCell, TableRow } from '@mui/material';
import { HTMLAttributes } from 'react';
import dayjs from 'dayjs';
import { DISPLAY_DATETIME_12H_FORMAT } from '@/utils/dateHelper';
import DehazeIcon from '@mui/icons-material/Dehaze';
import { useTranslation } from 'react-i18next';
import { OnoffType } from '@/api/enum/common.enum';
import { showLabel } from '@/utils/helper';

type Props = {
	item: any;
} & HTMLAttributes<HTMLDivElement>;

const SortableArticlesItem = ({ item }: Props) => {
	const { t } = useTranslation();
	const {
		attributes,
		isDragging,
		listeners,
		setNodeRef,
		transform,
		transition,
	} = useSortable({
		id: item.id,
	});

	const exerciseTypeList = [
		{
			id: 1,
			name: t('moment.meditation'),
		},
		{
			id: 2,
			name: t('moment.body'),
		},
		{
			id: 3,
			name: t('moment.crossover'),
		},
	];

	const onoffList = [
		{
			id: OnoffType.off,
			name: t('moment.off'),
		},
		{
			id: OnoffType.on,
			name: t('moment.on'),
		},
	];

	const styles = {
		transform: CSS.Transform.toString(transform),
		transition: transition || undefined,
		opacity: isDragging ? '0.4' : '1',
		backgroundColor: isDragging ? '#F5F5F5' : '',
	};

	return (
		<>
			<TableRow ref={setNodeRef} style={styles}>
				<TableCell component='th' scope='row'>
					<Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
						<DehazeIcon cursor={'pointer'} {...listeners} {...attributes} />
						{`${item.titleZh || '-'}`}
					</Box>
				</TableCell>
				<TableCell component='th' scope='row'>
					{showLabel(item?.exerciseType, exerciseTypeList)}
				</TableCell>
				<TableCell component='th' scope='row'>
					{`${item?.seriesTitleZh || '-'}`}
				</TableCell>
				<TableCell component='th' scope='row'>
					{`${item?.exerciseTime || '-'}`}
				</TableCell>
				<TableCell component='th' scope='row'>
					{
						<Chip
							color={
								item?.published == OnoffType.on ? 'chipPrimary' : 'default'
							}
							label={showLabel(item?.published, onoffList)}
						/>
					}
				</TableCell>
				<TableCell component='th' scope='row'>
					{`${
						!item.updatedAt
							? '-'
							: dayjs(item.updatedAt)
									.locale('en')
									.format(DISPLAY_DATETIME_12H_FORMAT)
					}`}
				</TableCell>
				<TableCell component='th' scope='row'>
					{`${
						!item.createdAt
							? '-'
							: dayjs(item.createdAt)
									.locale('en')
									.format(DISPLAY_DATETIME_12H_FORMAT)
					}`}
				</TableCell>
			</TableRow>
		</>
	);
};

export default SortableArticlesItem;
